import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// External Modules
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { UiSwitchModule } from 'ngx-ui-switch';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { SharedAngularMaterialModule } from '../shared-angular-material/shared-angular-material.module';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        SharedAngularMaterialModule
    ],
    declarations: [],
    exports: [
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatProgressBarModule,
        LoadingBarRouterModule,
        UiSwitchModule
    ]
})
export class SharedModule { }